import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';
import { whenResize } from '../../../../../paws/assets/frontend/js/helper/resize';

whenResize(resizeModule);
whenDocumentReady(initModule);
function initModule() {
    let charts = document.querySelectorAll('.noss_charts.line');
    window.charts = [];
    for (let i = 0; i < charts.length; ++i) {
        window.charts[i] = {
            element: charts[i],
            chart: false
        };
        CreateChart(i, charts[i], true);
    }
}

function resizeModule() {
    for (let i = 0; i < window.charts.length; ++i) {
        if (window.charts[i].chart) {
            window.charts[i].chart.resize();
        }
    }
}

function CreateChart(i, selector, isInit = false) {
    // get filter values
    let segment = selector.querySelector('[name="segment"]:checked').value;
    let days = selector.querySelectorAll('[name="day"]:checked');
    let areas = selector.querySelector('[name="area"]:checked').value;
    let yType = selector.querySelector('[name="y"]').value;

    if (window.charts[i].chart) {
        window.charts[i].chart.destroy();
    }

    let encodedDisplayData = '';

    if (segment === 'tv') {
        selector.classList.add('tv');
        selector.classList.remove('radio');
        encodedDisplayData = selector.dataset.nossChartTv;
    }
    else {
        selector.classList.remove('tv');
        selector.classList.add('radio');
        encodedDisplayData = selector.dataset.nossChartRadio;
    }

    if (encodedDisplayData) {

        let displayData = JSON.parse(encodedDisplayData);

        let finalDisplayData = [];
        for (let i = 0; i < days.length; ++i) {
            finalDisplayData.push(displayData[yType + '-' + areas + '-' + days[i].value])
        }

        let chartData = {
            datasets: finalDisplayData
        }

        let chartOptions = false;
        if (displayData[yType + '-' + areas + '-' + days[i].value]['highest'] > 0) {
            chartOptions = {
                locale: 'fr-CH',
                responsive: true,
                animation: {
                    duration: 0
                },
                scales: {
                    y: {
                        max: displayData[yType + '-' + areas + '-' + days[i].value]['highest'],
                    },
                    x: {
                        ticks: {
                            minRotation: 90,
                            maxRotation: 90,
                            callback: function(value, index) {
                                let label = this.getLabelForValue(value);
                                if (label.endsWith('05') || label.endsWith('35')) {
                                    return label;
                                }
                                return null;
                            }
                        }
                    }
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        enabled: true
                    }
                }
            };
        }
        else {
            chartOptions = {
                locale: 'fr-CH',
                responsive: true,
                animation: {
                    duration: 0
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        enabled: true
                    }
                }
            };
        }

        let chartConfig = {
            type: 'line',
            data: chartData,
            options: chartOptions
        };

        window.charts[i].chart = new Chart(selector.querySelector('canvas'),chartConfig);

        if (isInit === true) {
            // radio/tv button
            let segmentRadios = selector.querySelectorAll('[name="segment"]');
            for (let y = 0; y < segmentRadios.length; y++) {
                segmentRadios[y].addEventListener('change', function (event) {
                    event.preventDefault();
                    CreateChart(i, selector);
                });
            }

            // day button
            let dayCheckboxes = selector.querySelectorAll('[name="day"]');
            for (let y = 0; y < dayCheckboxes.length; y++) {
                dayCheckboxes[y].addEventListener('change', function (event) {
                    event.preventDefault();

                    // if none is checked -> force all checked
                    let dayCheckboxesChecked = selector.querySelectorAll('[name="day"]:checked');
                    if (dayCheckboxesChecked.length === 0) {
                        // force checking all
                        for (let z = 0; z < dayCheckboxes.length; z++) {
                            dayCheckboxes[z].checked = true;
                        }
                    }

                    CreateChart(i, selector);
                });
            }

            // day button
            let areaRadios = selector.querySelectorAll('[name="area"]');
            for (let y = 0; y < areaRadios.length; y++) {
                areaRadios[y].addEventListener('change', function (event) {
                    event.preventDefault();
                    CreateChart(i, selector);
                });
            }

            // y button
            let yValue = selector.querySelector('[type="hidden"][name="y"]');
            let ySpans = selector.querySelectorAll('.legend > span > span');;

            for (let y = 0; y < ySpans.length; y++) {
                ySpans[y].addEventListener('click', function (event) {
                    yValue.value = event.target.dataset.value;

                    for (let z = 0; z < ySpans.length; z++) {
                        if (ySpans[z].dataset.value === yValue.value) {
                            if (!ySpans[z].classList.contains('active')) {
                                ySpans[z].classList.add('active');
                            }
                        }
                        else {
                            ySpans[z].classList.remove('active');
                        }
                    }

                    CreateChart(i, selector);
                });
            }
        }
    }
}